import * as React from "react";

function SvgIcEdit(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 6a2 2 0 012-2h5a1 1 0 110 2H6v12h12v-6a1 1 0 112 0v6a2 2 0 01-2 2H6a2 2 0 01-2-2V6z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.555 3.103a2 2 0 012.894-.069l1.584 1.585a2 2 0 01.066 2.76l-2.08 2.287-4.97 5.654a2 2 0 01-1.502.68H9a1 1 0 01-1-1v-2.623a2 2 0 01.498-1.32l5.024-5.717.01-.013 2.023-2.224zm1.683 4.448l1.38-1.518-1.583-1.584-1.38 1.518 1.583 1.584zm-2.918-.09l1.583 1.583L11.547 14H10v-1.623l4.32-4.916z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcEdit;
